import { GuardianExpoSection } from './GuardianExpoSubPageLayout'
import ScheduleDayTabs from './ScheduleDayTabs'

/**
 * 挑戰賽賽程表區塊（tab 依日期切換，自動預選今天；整日一張表格）
 * days: [{ year, month, date, weekday, entries: [{ type: 'match', arrivalTime, matchTime, departureTime, matchups: [{ team, teamColor, isCourt, name, isWinner? }] } | { type: 'break', label, time }] }]
 */
export default function ChallengeScheduleSection({ titleBlack, titleRed, days, columnLabels, first = false, last = false }) {
  return (
    <GuardianExpoSection titleBlack={titleBlack} titleRed={titleRed} first={first} last={last}>
      <ScheduleDayTabs
        isChallengePage={true}
        days={days}
        renderDay={(day) => (
          <div className="flex flex-col items-center gap-3 self-stretch">
            <DayTable day={day} columnLabels={columnLabels} />
          </div>
        )}
      />
    </GuardianExpoSection>
  )
}

const TEAM_BG_COLORS = {
  A: 'rgba(188,49,61,0.08)',
  B: 'rgba(34,107,104,0.08)',
  C: 'rgba(0,70,130,0.08)',
  D: 'rgba(89,33,129,0.08)',
  E: 'rgba(197,155,90,0.08)',
  F: 'rgba(222,19,106,0.08)',
}

function TeamLabel({ team, court = team, name, color, isWinner }) {
  const bgColor = TEAM_BG_COLORS[team] ?? 'rgba(110,98,91,0.04)'
  const courtKey = court || 'A'
  const imgSrc = `/image/guardian-expo/${courtKey}${isWinner ? '1' : ''}.png`
  const isBgImg = true;
  if (isBgImg) {
    return (
      <div className="rounded-md inline-flex justify-start items-center overflow-hidden">
        <div className="relative inline-flex items-center justify-center">
          <img src={imgSrc} alt={`team-${courtKey}`} className="w-18" />
          <div className="absolute inset-0 flex items-center justify-center text-[var(--Black-Black,#171717)] text-lg font-normal font-['Noto_Sans_TC'] leading-6 pl-4 whitespace-nowrap">
            {name}
          </div>
        </div>
      </div>
    )
  } else {
    return (
      <div className="rounded-md inline-flex justify-start items-center overflow-hidden" style={{ backgroundColor: bgColor }}>
        <div
          className="w-10 self-stretch px-1 pb-px flex justify-center items-center gap-2.5"
          style={{ backgroundColor: color }}
        >
          {isWinner ? (
            <svg width="60%" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 10.5L2.5 4L6 7.5L8 2L10 7.5L13.5 4L15 10.5H1Z" fill="#F5C518" stroke="#E6A800" strokeWidth="0.5" strokeLinejoin="round" />
              <rect x="1" y="10.5" width="14" height="2" rx="0.5" fill="#F5C518" stroke="#E6A800" strokeWidth="0.5" />
              <circle cx="8" cy="2" r="1" fill="#E6A800" />
              <circle cx="1" cy="4" r="1" fill="#E6A800" />
              <circle cx="15" cy="4" r="1" fill="#E6A800" />
            </svg>
          ) : (
            <div className="w-[30%] justify-start text-[var(--White-White,#ffffff)] text-base font-normal font-['Noto_Sans_TC'] leading-6">
              {team}
            </div>
          )}
        </div>
        <div className="w-[70%] self-stretch px-1 pb-px flex justify-center items-center gap-2.5">
          <div className={`justify-start text-base font-['Noto_Sans_TC'] leading-6 ${isWinner ? 'text-[var(--Red-Red,#bc313d)] font-bold' : 'text-[var(--Black-Black,#171717)] font-normal'}`}>
            {name}
          </div>
        </div>
      </div>
    )
  }


}


function DayTable({ day, columnLabels }) {
  return (
    <div className="self-stretch rounded-sm outline outline-1 outline-offset-[-1px] outline-[var(--Brown-brown_12,rgba(110,98,91,0.12))] inline-flex flex-col justify-start items-start overflow-hidden">
      {/* Table header */}
      <div className="self-stretch h-7 bg-[var(--Brown-brown,#6e625b)] border-b border-[var(--Brown-brown_8,rgba(110,98,91,0.08))] inline-flex justify-start items-center">
        <div className="w-10 self-stretch flex justify-center items-center gap-2.5">
          <div className="justify-start text-[var(--White-White,#ffffff)] text-xs font-normal font-['Noto_Sans_TC'] leading-4">場次</div>
        </div>
        <div className="w-14 self-stretch border-l bg-[var(--Red-Red,#bc313d)] flex justify-center items-center gap-2.5">
          <div className="justify-center text-[var(--White-White,#ffffff)] text-xs font-normal font-['Noto_Sans_TC'] leading-4">到場時間</div>
        </div>
        <div className="w-14 self-stretch  border-l border-[var(--White-White_8,rgba(255,255,255,0.08))] flex justify-center items-center gap-2.5">
          <div className="justify-center text-[var(--White-White,#ffffff)] text-xs font-normal font-['Noto_Sans_TC'] leading-4">比賽時間</div>
        </div>
        <div className="flex-1 self-stretch border-l border-[var(--White-White_8,rgba(255,255,255,0.08))] flex justify-center items-center gap-2.5">
          <div className="justify-center text-[var(--White-White,#ffffff)] text-xs font-normal font-['Noto_Sans_TC'] leading-4">參賽隊伍</div>
        </div>
        {/* <div className="w-12 self-stretch border-l border-[var(--White-White_8,rgba(255,255,255,0.08))] flex justify-center items-center gap-2.5">
          <div className="justify-center text-[var(--White-White,#ffffff)] text-xs font-normal font-['Noto_Sans_TC'] leading-4">啦啦隊</div>
        </div> */}
      </div>

      {/* Table rows */}
      {day.entries
        .filter((entry) => entry.type !== 'break')
        .map((entry, matchIdx) => (
          <MatchRows key={matchIdx} entry={entry} isEven={matchIdx % 2 === 1} />
        ))}
    </div>
  )
}

function BreakRow({ entry }) {
  return (
    <div
      className="flex items-center justify-center self-stretch border-t border-Brown-brown_8"
      style={{ padding: '6px 12px', background: 'rgba(197,155,90,0.16)', gap: 8 }}
    >
      <span style={{ color: '#6E625B', fontFamily: 'Noto Sans TC', fontSize: 13, fontWeight: 500, lineHeight: '20px' }}>
        {entry.label}
      </span>
      <span style={{ color: '#6E625B', fontFamily: 'Noto Sans TC', fontSize: 13, fontWeight: 700, lineHeight: '20px' }}>
        {entry.time}
      </span>
    </div>
  )
}

function MatchRows({ entry, isEven }) {
  return (
    <div className={`self-stretch border-b-[0.50px] border-[var(--Brown-brown_20,rgba(110,98,91,0.20))] inline-flex justify-start items-center ${isEven ? 'bg-[var(--light-brown-lBrown50,#FEFCF8)]' : 'bg-white'}`}>
      {/* 場次 */}
      <div className="w-10 self-stretch flex justify-center items-center gap-2.5">
        <div className="justify-start text-[var(--Brown-brown,#6e625b)] text-base font-normal font-['Noto_Sans_TC'] leading-7">
          {entry.match}
        </div>
      </div>
      {/* 到場時間 */}
      <div className="w-14 self-stretch py-2 border-l border-[var(--Brown-brown_8,rgba(110,98,91,0.08))] flex justify-center items-center gap-2.5">
        <div className="w-11 h-20 flex flex-col items-center justify-center text-[var(--Red-Red,#bc313d)] text-lg font-medium font-['Noto_Sans_TC'] leading-5">
          <span>{entry.arrivalTime}</span>
        </div>
      </div>

      {/* 比賽時間 */}
      <div className="w-14 self-stretch py-2 border-l border-[var(--Brown-brown_8,rgba(110,98,91,0.08))] flex justify-center items-center gap-2.5">
        <div className="w-11 h-20 flex flex-col items-center justify-center  text-[var(--Brown-brown,#6e625b)] text-base font-medium font-['Noto_Sans_TC'] leading-5">
          <span>{entry.matchTime}</span>
          {/* <span>┃</span>
          <span>{entry.departureTime}</span> */}
        </div>
      </div>

      {/* 參賽隊伍 */}
      <div className="flex-1 self-stretch border-l border-[var(--Brown-brown_8,rgba(110,98,91,0.08))] flex flex-wrap justify-start items-center content-center gap-1 px-2 py-1">
        {entry.matchups
          .filter((m) => !["啦啦隊", "啦啦隊1", "啦啦隊2"].includes(m.team))
          .map((m, i) => (
            <TeamLabel key={i} team={m.team} name={m.name} color={m.teamColor} isWinner={m.isWinner} />
          ))}
      </div>

      {/* 啦啦隊 */}
      {/* <div className="w-12 self-stretch border-l border-[var(--Brown-brown_8,rgba(110,98,91,0.08))] flex flex-col justify-center items-center gap-1 py-1">
        {entry.matchups
          .filter((m) => ["啦啦隊", "啦啦隊1", "啦啦隊2"].includes(m.team))
          .map((m, i) => (
            <div key={i} className="text-center text-[var(--Black-Black,#171717)] text-base font-normal font-['Noto_Sans_TC'] leading-6">
              {m.name}
            </div>
          ))}
      </div> */}
    </div>
  )
}
